import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of, switchMap, tap } from 'rxjs';
import { usersManageApi } from 'src/app/shared/constants/api.constants';
import { IUser } from '../../shared/models/IUser.model';
import { UserService } from '../user.service';
import { HttpBaseService }   from '@evento-ng/libs';

@Component({
  selector: 'app-root-account',
  templateUrl: './root-account.component.html',
})
export class RootAccountComponent implements OnInit {
  user$: Observable<IUser>;
  active = 'personalAccount';

  constructor(
    private dataService: HttpBaseService,
    private userService: UserService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.user$ = this.route.params.pipe(
      switchMap((params) => {
        const { id } = params;
        if (id) {
          return this.dataService.get(`${usersManageApi}/${id}`);
        }
        return of(null);
      }),
      tap((user) => this.userService.selectedUser$.next(user))
    );
  }
}
